import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// import { DiscountCodeCon } from './skins';
import IconClose from '../atoms/IconClose';
import MFlexbox from '../atoms/MFlexbox';
import IconDiscountTag from '../atoms/IconDiscountTag';
import { MButton } from '../atoms/MButton';
import CircularProgress from '../atoms/CircularProgress';
import { MText } from '../atoms/MText';
import { MInput } from '../atoms/MInput';

import { StyledDiscountCodeCon } from './skins';
import { deleteCookie } from '../../../common/cookies';
// eslint-disable-next-line import/no-cycle
import {
  getFreeShippingCodefromStorage,
  getGraphqlCachedData,
  getIsShopifyFunctionsEnabled,
  getMonkAppliedCodes,
  getMrFreegiftDiscountCode,
  getShopifyMonkCodesMapping,
  setMRAppliedDiscountCodes,
  setMrDiscountCode,
  setMRFreeShippingCode,
} from '../../../common/settings';

export const MDiscountCode = props => {
  const {
    offerType,
    isBundled = false,
    onApply,
    // isBordered,
    discountCodeStyles = {},
    cartPageDiscountConfig,
    isDiscountCodeEnabled,
    isInsidePopupWidget,
    isDiscountCodePopup = false,
    discountCodeValues,
    onDiscountCodeRemove,
    initialAppliedCode,
    initialIsDisplayAppliedInfo = false,
    isAutoAppliedFreegiftDiscountCode = false,
    getDiscountCodeFromApps,
    isSkipShopifyDiscountAPICall,
    mrCart = [],
    shopifyMonkCodesMapping = {},
  } = props;

  const [showDiscountForm, setShowDiscountForm] = useState(!isBundled);

  const [code, setCode] = useState('');
  const [applying, setApplying] = useState(false);
  const [appliedCode, setAppliedCode] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [isDisplayAppliedInfo, setIsDisplayAppliedInfo] = useState(false);
  const [freegiftRuleCodes, setFreegiftRuleCodes] = useState([]);
  const [discountCodes, setDiscountCodes] = useState([]);
  const [discountCodesMapping, setDiscountCodesMapping] = useState(null);
  const [errorMsg, setErrorMsg] = useState(
    discountCodeStyles.discountCodeInvalidText,
  );
  const [freeShippingCode, setFreeShippingCode] = useState('');
  const isShopifyFunctionsEnabled = getIsShopifyFunctionsEnabled();

  // to check if code is monk's code or shopify code
  const isMonkCode = (discountCode, res) => {
    if (res) {
      return Object.keys(res).some(item => {
        if (res[item].codes.includes(discountCode)) {
          return true;
        }
        return false;
      });
    }
    return false;
  };

  // let say a funnel has multiple codes, one of them is already applied, and passed code is another code, then return applied code
  const getSimilarCode = newCode => {
    // const fgCode = getMappedShopifyCode(newCode) || newCode;
    if (discountCodesMapping && freegiftRuleCodes.includes(newCode)) {
      for (let i = 0; i < discountCodes.length; i += 1) {
        if (freegiftRuleCodes.includes(discountCodes[i])) {
          return discountCodes[i];
        }
      }
    }
    return '';
  };

  // extracting line level and cart level discount from passed data.
  const extractCodesFromShopifyResponse = graphqlResponseData => {
    const appliedCodes = [];
    graphqlResponseData.storefrontCart.discountAllocations.forEach(
      ({ code: cartCode }) => {
        if (cartCode) {
          appliedCodes.push(cartCode.toString().toUpperCase());
        }
      },
    );
    graphqlResponseData.storefrontCart.lines.edges.forEach(
      ({ node: { discountAllocations } }) => {
        discountAllocations.forEach(({ code: itemCode }) => {
          if (itemCode) {
            appliedCodes.push(itemCode.toString().toUpperCase());
          }
        });
      },
    );
    return [...new Set(appliedCodes)];
  };

  const getShopifyAppliedCodeAndMonkFunnelNameCodes = (
    graphqlCachedData,
    mrDiscountCodesMap,
    freegiftFunnelNameCodes,
    monkAppliedCodes,
    monkFunnelNameCodes,
  ) => {
    const initialAppliedCodes = [];
    try {
      if (
        graphqlCachedData &&
        graphqlCachedData.mrSF &&
        graphqlCachedData.mrSF.codes &&
        mrDiscountCodesMap
      ) {
        // this is for monk's codes
        graphqlCachedData.mrSF.codes.forEach(discountCode => {
          if (freegiftFunnelNameCodes.includes(discountCode)) {
            for (
              let i = 0;
              i < mrDiscountCodesMap[discountCode].codes.length;
              i += 1
            ) {
              if (
                monkAppliedCodes.includes(
                  mrDiscountCodesMap[discountCode].codes[i],
                )
              ) {
                initialAppliedCodes.push(
                  mrDiscountCodesMap[discountCode].codes[i],
                );
                break;
              }
            }
          } else if (
            !isMonkCode(discountCode, mrDiscountCodesMap) &&
            !monkFunnelNameCodes.includes(discountCode)
          ) {
            // this is for shopify code
            initialAppliedCodes.push(discountCode);
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
    return initialAppliedCodes;
  };

  const getMonkFunnelNameCodes = async () => {
    const sfModule = await import('../../../features/shopifyFunctionsDiscount');
    const allMrShopifyFunctionAppliedDiscountCodes = sfModule.getShopifyFunctionsProductData();
    if (allMrShopifyFunctionAppliedDiscountCodes) {
      return Object.keys(allMrShopifyFunctionAppliedDiscountCodes).map(key =>
        key.toString().toUpperCase(),
      );
    }
    return [];
  };

  const getFreeGiftFunnelNameCodes = mrDiscountCodesMap => {
    if (mrDiscountCodesMap) {
      return Object.keys(mrDiscountCodesMap);
    }
    return [];
  };

  const getMonkFGRuleCodes = (freegiftFunnelNameCodes, mrDiscountCodesMap) => {
    const monkFGRuleCodes = [];
    freegiftFunnelNameCodes.forEach(fgCode => {
      mrDiscountCodesMap[fgCode].codes.forEach(monkCode => {
        monkFGRuleCodes.push(monkCode);
      });
    });
    setFreegiftRuleCodes(monkFGRuleCodes);
    return monkFGRuleCodes;
  };

  const getFreeShippingCode = () => {
    const mrFreeShippingCode = getFreeShippingCodefromStorage();
    if (mrFreeShippingCode) {
      setFreeShippingCode(mrFreeShippingCode);
      return mrFreeShippingCode;
    }
    return '';
  };

  // mrDiscountCodesMap containes FG-funnel-name(funnel title) with mapping of FG codes and productId's
  const getInitialAppliedCodes = async mrDiscountCodesMap => {
    const initialAppliedCodes = [];
    const preAppliedCodeThroughUrl = getMrFreegiftDiscountCode();

    // graphqlCachedData is graphql response with applied codes in seesion storage
    const graphqlCachedData = getGraphqlCachedData();
    const monkAppliedCodes = getMonkAppliedCodes();
    if (Object.keys(mrDiscountCodesMap).length) {
      setDiscountCodesMapping(mrDiscountCodesMap);
    }
    // allMrShopifyFunctionAppliedDiscountCodes is mapping of funnel title and eligible productId's
    const monkFunnelNameCodes = await getMonkFunnelNameCodes();

    const freegiftFunnelNameCodes = getFreeGiftFunnelNameCodes(
      mrDiscountCodesMap,
    );

    // get codes from graphqlCachedData
    const graphqlAppliedCodes = getShopifyAppliedCodeAndMonkFunnelNameCodes(
      graphqlCachedData,
      mrDiscountCodesMap,
      freegiftFunnelNameCodes,
      monkAppliedCodes,
      monkFunnelNameCodes,
    );

    initialAppliedCodes.push(...graphqlAppliedCodes);

    const monkFGRuleCodes = getMonkFGRuleCodes(
      freegiftFunnelNameCodes,
      mrDiscountCodesMap,
    );

    const mrFreeShippingCode = getFreeShippingCode();
    if (mrFreeShippingCode) {
      initialAppliedCodes.push(mrFreeShippingCode);
    }
    // below step is for showing FG code when only widget is displayed, and FG code not persent in graphql response
    initialAppliedCodes.push(
      ...monkAppliedCodes.filter(monkAppliedCode =>
        monkFGRuleCodes.includes(monkAppliedCode),
      ),
    );
    // mrFdc is present in url and freegift code not applied then, push into initialAppliedCodes and monkAppliedCodes
    if (
      preAppliedCodeThroughUrl &&
      !getAppliedFreegiftRuleCode(initialAppliedCodes, monkFGRuleCodes) &&
      monkFGRuleCodes.includes(preAppliedCodeThroughUrl.toUpperCase())
    ) {
      initialAppliedCodes.push(preAppliedCodeThroughUrl.toUpperCase());
      monkAppliedCodes.push(preAppliedCodeThroughUrl.toUpperCase());
      setMRAppliedDiscountCodes([...new Set(monkAppliedCodes)]);
    }
    setDiscountCodes([...new Set(initialAppliedCodes)]);
  };

  useEffect(
    () => {
      if (isShopifyFunctionsEnabled && shopifyMonkCodesMapping) {
        getInitialAppliedCodes(shopifyMonkCodesMapping);
      }
    },
    // whenever cart cahnges or shopifyMonkCodesMapping which map of freegift funnel name code and monk fg codes, changes
    [mrCart.length, JSON.stringify(shopifyMonkCodesMapping)],
  );

  const onApplySuccess = () => {
    document.documentElement.dispatchEvent(
      new CustomEvent('mrDiscountCode:apply', {
        bubbles: true,
        detail: { offerType },
      }),
    );

    // for some stores, discount code must not be set in shopify cookies,
    // so avoid the API call
    if (isSkipShopifyDiscountAPICall) {
      return;
    }

    // storing discount code in shopify
    fetch(`/discount/${code}`);
  };

  const onRemoveSuccess = () => {
    document.documentElement.dispatchEvent(
      new CustomEvent('mrDiscountCode:remove', {
        bubbles: true,
        detail: { offerType },
      }),
    );
  };

  const handleAlreadyAppliedCode = alreadyAppliedCode => {
    setIsValid(false);
    setAppliedCode(code);
    setErrorMsg(
      discountCodeStyles.discountCodeCombineErrorText.replace(
        '{{other_code}}',
        alreadyAppliedCode,
      ),
    );
  };

  const validateFreeShippingCode = () => {
    if (!freeShippingCode) {
      const newDiscountCodes = [...discountCodes, code];
      setDiscountCodes([...new Set(newDiscountCodes)]);
      setMRFreeShippingCode(code);
      setFreeShippingCode(code);
      setIsValid(true);
      return;
    }
    setErrorMsg(
      discountCodeStyles.discountCodeCombineErrorText.replace(
        '{{other_code}}',
        freeShippingCode,
      ),
    );
    setIsValid(false);
    setAppliedCode(code);
  };

  const validateDiscountCode = response => {
    // if code is monk's FG code then add to the list else check if code from response is present inside allShopifyAppliedCodes then it is valid code
    if (isMonkCode(code, discountCodesMapping)) {
      const newDiscountCodes = [...discountCodes, code];
      setDiscountCodes([...discountCodes, code]);
      // remove free shipping code from the list if present
      if (freeShippingCode) {
        const fsIndex = newDiscountCodes.indexOf(freeShippingCode);
        if (fsIndex !== -1) {
          newDiscountCodes.splice(fsIndex, 1);
        }
      }
      setMRAppliedDiscountCodes(newDiscountCodes);
      return;
    }
    if (response.discountCode.isFreeShippingCode) {
      validateFreeShippingCode(response);
      return;
    }
    const allShopifyAppliedCodes = extractCodesFromShopifyResponse(
      response.data,
    );
    if (allShopifyAppliedCodes.includes(code)) {
      const newDiscountCodes = [...discountCodes, code];
      // remove invalied codes, which were valid before
      // e.g. SHOPIFY1:get 10% off, SHOPIFY2:get 20% off
      // first SHOPIFY1 was applied, when SHOPIFY2 is applied, SHOPIFY1 should be removed
      // filter out all codes which are not freegift codes, free shipping code and applied shopify codes
      const newFilteredDiscountCodes = newDiscountCodes.filter(
        discountCode =>
          freegiftRuleCodes.includes(discountCode) ||
          discountCode === freeShippingCode ||
          allShopifyAppliedCodes.includes(discountCode),
      );
      setDiscountCodes([...new Set(newFilteredDiscountCodes)]);
      setMRAppliedDiscountCodes([...new Set(newFilteredDiscountCodes)]);
      setAppliedCode(code);
      setIsValid(true);
      return;
    }
    setMrDiscountCode('');
    setIsValid(false);
    setErrorMsg(discountCodeStyles.discountCodeInvalidText);
  };

  const getAppliedFreegiftRuleCode = (
    appliedCodes = discountCodes,
    fgRuleCodes = freegiftRuleCodes,
  ) => {
    for (let i = 0; i < appliedCodes.length; i += 1) {
      if (fgRuleCodes.includes(appliedCodes[i])) {
        return appliedCodes[i];
      }
    }
    return '';
  };

  const checkForCombinationEnabled = (isFGRuleCode, fgAppliedRuleCode) => {
    if (isFGRuleCode) {
      return false;
    }
    if (fgAppliedRuleCode) {
      return true;
    }
    return false;
  };

  const handleEnteredCodeCanNotCombineWithFGCode = fgAppliedRuleCode =>
    handleAlreadyAppliedCode(fgAppliedRuleCode);

  const handleDiscountCodeApply = (
    response,
    isFGRuleCode,
    fgAppliedRuleCode,
  ) => {
    if (response && response.discountCode && response.discountCode.isValid) {
      // when freegift code is applead and use enters a shopify code which has combine code is not set,
      // then will get isProductCombinationEnabled false
      // when isProductCombinationEnabled is false, entered code is not FG code and FG code is already applied
      // then will show error : code can not combine with freegift code.
      const isAppledCodeCanNotCombineWithFGAppliedCode =
        !response.discountCode.isProductCombinationEnabled &&
        !isFGRuleCode &&
        fgAppliedRuleCode;
      if (isAppledCodeCanNotCombineWithFGAppliedCode) {
        handleEnteredCodeCanNotCombineWithFGCode(fgAppliedRuleCode);
        return;
      }
      validateDiscountCode(response);
      onApplySuccess();
      return;
    }
    setIsValid(false);
    setErrorMsg(discountCodeStyles.discountCodeInvalidText);
  };

  const handleFunctionsStoreDiscountCodeApply = async () => {
    // code is aready applied
    if (discountCodes.includes(code)) {
      handleAlreadyAppliedCode(code);
      return;
    }
    const similarAppliedCode = getSimilarCode(code);
    // for example
    // free gift funnel has 2 code, free1 & free2
    // free1 is already applied
    // when user enters free2, free1 will be "similar" code
    if (similarAppliedCode) {
      handleAlreadyAppliedCode(similarAppliedCode);
      return;
    }
    if (!isInsidePopupWidget) setApplying(true);
    const isFGRuleCode = freegiftRuleCodes.includes(code.toUpperCase());
    const fgAppliedRuleCode = getAppliedFreegiftRuleCode();

    const response = await onApply(
      {
        code,
        action: 'apply',
        checkForCombinationEnabled: checkForCombinationEnabled(
          isFGRuleCode,
          fgAppliedRuleCode,
        ),
      },
      cartPageDiscountConfig,
      isDiscountCodeEnabled,
    );
    if (!response) {
      setApplying(false);
      return;
    }
    if (!isInsidePopupWidget) {
      setApplying(false);
      setAppliedCode(code);
      setIsDisplayAppliedInfo(response.isDisplayAppliedInfo);
      if (response.isValid === false) {
        setTimeout(() => {
          setAppliedCode(null);
        }, 10000);
      }
    }
    handleDiscountCodeApply(response, isFGRuleCode, fgAppliedRuleCode);
    setApplying(false);
    setCode('');
  };

  const onRemove = async removedCode => {
    if (!isInsidePopupWidget) {
      const sfModule = await import('../../../features/shopifyFunctionsDiscount');
      await onApply(
        {
          action: 'remove',
          code: isShopifyFunctionsEnabled
            ? sfModule.getMappedShopifyCode(
                removedCode,
                discountCodesMapping,
              ) || removedCode
            : removedCode,
        },
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
      );
      setApplying(false);
      setIsValid(false);
      setAppliedCode(null);
      setIsDisplayAppliedInfo(false);
      if (isShopifyFunctionsEnabled) {
        // for shopify functions store
        const allAppliedCodes = [...discountCodes];
        const idx = allAppliedCodes.indexOf(removedCode);
        if (idx !== -1) {
          allAppliedCodes.splice(idx, 1);
        }
        setDiscountCodes(allAppliedCodes);
        if (removedCode === freeShippingCode) {
          setFreeShippingCode('');
          setMRFreeShippingCode('');
        }
        setMRAppliedDiscountCodes(allAppliedCodes);
      }
    } else {
      onDiscountCodeRemove();
    }
    onRemoveSuccess();
    deleteCookie('discount_code');
  };

  const submitHandler = async e => {
    e.preventDefault();
    if (!isShopifyFunctionsEnabled) {
      if (!isInsidePopupWidget) setApplying(true);
      const response = await onApply(
        { code, action: 'apply' },
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
      );
      if (!isInsidePopupWidget) {
        setApplying(false);
        setAppliedCode(code);
        setIsValid(response.isValid);
        setIsDisplayAppliedInfo(response.isDisplayAppliedInfo);

        if (response.isValid === false) {
          setTimeout(() => {
            setAppliedCode(null);
          }, 10000);
        }
      }
      setCode('');
      if (response && response.isValid) {
        onApplySuccess();
      }
      return;
    }
    // shopify functions store discount apply handling
    handleFunctionsStoreDiscountCodeApply();
  };

  const isEmbedded = !isInsidePopupWidget && !isDiscountCodePopup;

  useEffect(
    () => {
      if (isInsidePopupWidget) {
        setApplying(discountCodeValues.applying);
        setAppliedCode(discountCodeValues.appliedCode);
        setIsValid(discountCodeValues.isValid);
      }
    },
    [discountCodeValues],
  );

  useEffect(
    () => {
      if (initialAppliedCode && !isShopifyFunctionsEnabled) {
        setAppliedCode(initialAppliedCode);
        setIsValid(true);
        setIsDisplayAppliedInfo(initialIsDisplayAppliedInfo);
        if (isAutoAppliedFreegiftDiscountCode) {
          onApplySuccess();
        }
      } else if (getDiscountCodeFromApps) {
        const discountCodeInSession = getDiscountCodeFromApps();
        if (discountCodeInSession && discountCodeInSession.code) {
          setAppliedCode(discountCodeInSession.code);
          setIsValid(true);
        }
      }
    },
    [initialAppliedCode],
  );

  const isCodeEntered = code !== '';
  const isInvalidCode = appliedCode !== null && !isValid;
  const isValidCode = appliedCode !== null && isValid;

  /* eslint-disable no-nested-ternary */
  // const discountCodeInputBorderColor =
  //   discountCodeStyles.discountCodeInputBorderColor;
  const discountCodeInputBorderColor = isCodeEntered
    ? discountCodeStyles.discountCodeButtonColor
    : isInvalidCode
      ? discountCodeStyles.discountCodeInvalidTextColor
      : isValidCode
        ? discountCodeStyles.discountCodeDefaultButtonColor
        : discountCodeStyles.discountCodeInputBorderColor;
  /* eslint-enable no-nested-ternary */

  const discountCodeButtonWidth =
    !discountCodeStyles.discountCodeButtonWidth ||
    discountCodeStyles.discountCodeButtonWidth === '0'
      ? `${discountCodeStyles.discountCodeButtonText.length + 4}ch`
      : discountCodeStyles.discountCodeButtonWidth;

  const isCodeInputDisabled =
    applying || (!isShopifyFunctionsEnabled && appliedCode);

  return (
    <StyledDiscountCodeCon
      // isBordered={isBordered}
      // isCodeEntered={code !== ''}
      // isInvalidCode={appliedCode !== null && !isValid}
      // padding={isBundled && '0px'}
      backgroundColor={discountCodeStyles.discountCodeWidgetBackgroundColor}
      padding={discountCodeStyles.discountCodeWidgetPadding}
      margin={discountCodeStyles.discountCodeWidgetMargin}
      className="mr-discount-code"
    >
      <MFlexbox ai="center" width="100%">
        <form onSubmit={submitHandler} className="mr-discount-code-form">
          {showDiscountForm ? (
            <>
              <MInput
                value={code}
                placeholder={discountCodeStyles.discountCodeInputPlaceholder}
                onChange={e => setCode(e.target.value.toUpperCase())}
                backgroundColor={
                  discountCodeStyles.discountCodeInputBackgroundColor
                }
                borderColor={discountCodeInputBorderColor}
                borderRadius={discountCodeStyles.discountCodeInputBorderRadius}
                fontSize={discountCodeStyles.discountCodeButtonFontSize}
                mobileFontSize={
                  discountCodeStyles.discountCodeButtonMobileFontSize
                }
                width="auto"
                height={discountCodeStyles.discountCodeButtonHeight}
                padding={discountCodeStyles.discountCodeInputPadding}
                margin={discountCodeStyles.discountCodeInputMargin}
                className="mr-discount-code-form__input mr-grow"
                disabled={isCodeInputDisabled}
              />
              <MButton
                buttonStyle={discountCodeStyles.discountCodeButtonStyle}
                backgroundColor={
                  !isCodeEntered
                    ? discountCodeStyles.discountCodeDefaultButtonColor
                    : discountCodeStyles.discountCodeButtonColor
                }
                fontSize={discountCodeStyles.discountCodeButtonFontSize}
                mobileFontSize={
                  discountCodeStyles.discountCodeButtonMobileFontSize
                }
                textColor={discountCodeStyles.discountCodeButtonTextColor}
                borderRadius={discountCodeStyles.discountCodeButtonBorderRadius}
                borderColor={
                  !isCodeEntered
                    ? discountCodeStyles.discountCodeDefaultButtonColor
                    : discountCodeStyles.discountCodeButtonColor
                }
                fontStyle={discountCodeStyles.discountCodeButtonFontStyle}
                textDecoration={
                  discountCodeStyles.discountCodeButtonTextDecoration
                }
                fontWeight={discountCodeStyles.discountCodeButtonFontWeight}
                textAlignment={
                  discountCodeStyles.discountCodeButtonTextAlignment
                }
                fontFamily={discountCodeStyles.discountCodeButtonFontFamily}
                height={discountCodeStyles.discountCodeButtonHeight}
                width={discountCodeButtonWidth}
                padding={discountCodeStyles.discountCodeButtonPadding}
                margin={discountCodeStyles.discountCodeButtonMargin}
                attributes={{ type: 'submit' }}
                disabled={!isCodeEntered}
                className="mr-discount-code-form__button"
              >
                {applying ? (
                  <CircularProgress
                    fontSize={discountCodeStyles.discountCodeButtonFontSize}
                    mobileFontSize={
                      discountCodeStyles.discountCodeButtonMobileFontSize
                    }
                    color={discountCodeStyles.discountCodeButtonTextColor}
                    className="mr-discount-code-form__button-loading"
                  />
                ) : (
                  discountCodeStyles.discountCodeButtonText
                )}
              </MButton>
            </>
          ) : (
            <MButton
              onClick={() => setShowDiscountForm(true)}
              buttonStyle="text"
              backgroundColor="transparent"
              borderColor="transparent"
              textColor={discountCodeStyles.discountCodeEnabledTextColor}
              fontSize={discountCodeStyles.discountCodeEnabledFontSize}
              mobileFontSize={
                discountCodeStyles.discountCodeEnabledMobileFontSize
              }
              fontStyle={discountCodeStyles.discountCodeEnabledFontStyle}
              fontWeight={discountCodeStyles.discountCodeEnabledFontWeight}
              textDecoration={
                discountCodeStyles.discountCodeEnabledTextDecoration
              }
              fontFamily={discountCodeStyles.discountCodeEnabledFontFamily}
              textAlignment={
                discountCodeStyles.discountCodeEnabledTextAlignment
              }
              padding={discountCodeStyles.discountCodeEnabledPadding}
              margin={discountCodeStyles.discountCodeEnabledMargin}
              width="100%"
              className="mr-discount-code-form__toggle-text"
            >
              {discountCodeStyles.discountCodeEnabledText}
            </MButton>
          )}
        </form>
      </MFlexbox>
      {isInvalidCode && (
        <MText
          color={discountCodeStyles.discountCodeInvalidTextColor}
          fontSize={discountCodeStyles.discountCodeInvalidFontSize}
          mobileFontSize={discountCodeStyles.discountCodeInvalidMobileFontSize}
          fontStyle={discountCodeStyles.discountCodeInvalidFontStyle}
          fontWeight={discountCodeStyles.discountCodeInvalidFontWeight}
          textDecoration={discountCodeStyles.discountCodeInvalidTextDecoration}
          textAlignment={discountCodeStyles.discountCodeInvalidTextAlignment}
          fontFamily={discountCodeStyles.discountCodeInvalidFontFamily}
          padding={discountCodeStyles.discountCodeInvalidPadding}
          margin={discountCodeStyles.discountCodeInvalidMargin}
          className="mr-discount-code__error-text"
        >
          {errorMsg}
        </MText>
      )}
      {isShopifyFunctionsEnabled && (
        <MFlexbox
          flexWrap="wrap"
          gap="4px"
          className="mr-discount-code__applied-code"
        >
          {discountCodes.map((discountCode, index) => (
            <MFlexbox
              ai="center"
              gap="6px"
              backgroundColor={
                discountCodeStyles.discountCodeChipBackgroundColor
              }
              borderRadius={discountCodeStyles.discountCodeChipBorderRadius}
              padding={discountCodeStyles.discountCodeChipPadding}
              margin={discountCodeStyles.discountCodeChipMargin}
              className="mr-applied-code-chip"
            >
              <IconDiscountTag
                fontSize={14}
                className="mr-applied-code-chip__discount-icon"
              />
              <MText
                fontSize={discountCodeStyles.discountCodeChipFontSize}
                className="mr-applied-code-chip__text"
              >
                {discountCode}
              </MText>
              <IconClose
                fontSize={10}
                onClick={() => onRemove(discountCode)}
                className="mr-applied-code-chip__close-icon"
              />
            </MFlexbox>
          ))}
        </MFlexbox>
      )}
      {!isShopifyFunctionsEnabled &&
        isValidCode && (
          <MFlexbox gap="4px" className="mr-discount-code__applied-code">
            <MFlexbox
              ai="center"
              gap="6px"
              backgroundColor={
                discountCodeStyles.discountCodeChipBackgroundColor
              }
              borderRadius={discountCodeStyles.discountCodeChipBorderRadius}
              padding={discountCodeStyles.discountCodeChipPadding}
              margin={discountCodeStyles.discountCodeChipMargin}
              className="mr-applied-code-chip"
            >
              <IconDiscountTag
                fontSize={14}
                className="mr-applied-code-chip__discount-icon"
              />
              <MText
                fontSize={discountCodeStyles.discountCodeChipFontSize}
                className="mr-applied-code-chip__text"
              >
                {appliedCode}
              </MText>
              <IconClose
                fontSize={10}
                onClick={() => onRemove(appliedCode)}
                className="mr-applied-code-chip__close-icon"
              />
            </MFlexbox>
          </MFlexbox>
        )}
      {isShopifyFunctionsEnabled &&
        freeShippingCode && (
          <MText
            color={discountCodeStyles.discountCodeAppliedInfoTextColor}
            fontSize={discountCodeStyles.discountCodeAppliedInfoFontSize}
            mobileFontSize={
              discountCodeStyles.discountCodeAppliedInfoMobileFontSize
            }
            fontStyle={discountCodeStyles.discountCodeAppliedInfoFontStyle}
            fontWeight={discountCodeStyles.discountCodeAppliedInfoFontWeight}
            textDecoration={
              discountCodeStyles.discountCodeAppliedInfoTextDecoration
            }
            textAlignment={
              discountCodeStyles.discountCodeAppliedInfoTextAlignment
            }
            fontFamily={discountCodeStyles.discountCodeAppliedInfoFontFamily}
            padding={discountCodeStyles.discountCodeAppliedInfoPadding}
            margin={discountCodeStyles.discountCodeAppliedInfoMargin}
            className="mr-discount-code__info-text"
          >
            {discountCodeStyles.fsDiscountCodeAppliedInfoText}
          </MText>
        )}
    </StyledDiscountCodeCon>
  );
};

MDiscountCode.propTypes = {
  offerType: PropTypes.string,
  isBundled: PropTypes.bool,
  onApply: PropTypes.func.isRequired,
  // isBordered: PropTypes.bool,
  discountCodeStyles: PropTypes.object,
  cartPageDiscountConfig: PropTypes.object,
  isDiscountCodeEnabled: PropTypes.bool,
  isInsidePopupWidget: PropTypes.bool,
  isDiscountCodePopup: PropTypes.bool,
  discountCodeValues: PropTypes.object,
  onDiscountCodeRemove: PropTypes.func,
  initialAppliedCode: PropTypes.string,
  initialIsDisplayAppliedInfo: PropTypes.bool,
  isAutoAppliedFreegiftDiscountCode: PropTypes.bool,
  getDiscountCodeFromApps: PropTypes.func.isRequired,
  isSkipShopifyDiscountAPICall: PropTypes.bool,
  mrCart: PropTypes.array,
  shopifyMonkCodesMapping: PropTypes.object,
};
